import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type MutationError
} from '@/hooks/useMutationWithErrorsHandling'
import queryClient from '@/queryClient'

import {
  type CourseFormPayload,
  fieldErrorsMapper
} from '../constants/course-payload'

const useEditCourse = (options: {
  id: string
  onSuccess?: (data: {
    response: { id: string }
    variables: CourseFormPayload
  }) => void
  onError?: (data: {
    errors: MutationError<CourseFormPayload, unknown>
    variables: CourseFormPayload
  }) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: async (data: CourseFormPayload) =>
      httpService.panel.panelCoursesUpdate(options.id, {
        name: data.name,
        education_level: data.educationLevel,
        domain: data.domain.value,
        preferred_rooms: data.preferredRooms?.map(room => room.value)
      }),
    onSuccess: async (response, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['panelCoursesManagementRetrieve', response.id]
      })
      queryClient.invalidateQueries({
        queryKey: ['panelCoursesManagementList']
      })

      return options?.onSuccess?.({ response, variables })
    },
    onError: (errors, variables) => options?.onError?.({ errors, variables }),
    fieldErrorsMapper
  })

export default useEditCourse
